// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2_Jzl","filesListContainer":"PosDisputesFiles_filesListContainer__1aZ6G","filesButton":"PosDisputesFiles_filesButton__T-RW1"};